import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['VehicleType'],
});

export const vehicleTypeApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllVehicleType: builder.query({
      query: () => `vehicle_types/`,
      providesTags: ['VehicleType'],
    }),
    findVehicleTypeById: builder.query({
      query: (id) => `vehicle_types/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'VehicleType', id: result.id }]
          : ['VehicleType'];
      },
    }),
    createVehicleType: builder.mutation({
      query: (VehicleType) => ({
        url: `vehicle_types/`,
        method: 'POST',
        body: VehicleType,
      }),
      invalidatesTags: ['VehicleType'],
    }),
    updateVehicleType: builder.mutation({
      query: (VehicleType) => ({
        url: `vehicle_types/${VehicleType.id}/`,
        method: 'PATCH',
        body: VehicleType,
      }),
      invalidatesTags: ['VehicleType'],
    }),
    deleteVehicleType: builder.mutation({
      query: (VehicleType) => ({
        url: `vehicle_types/${VehicleType.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['VehicleType'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllVehicleTypeQuery,
  useFindVehicleTypeByIdQuery,
  useCreateVehicleTypeMutation,
  useUpdateVehicleTypeMutation,
  useDeleteVehicleTypeMutation,
} = vehicleTypeApi;
